import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';

const styles = StyleSheet.create({
    marker: {
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: COLOR.primary,
        height: 20,
        borderRadius: 20,
        marginRight: 8,
    },
    markerIcons: {
        marginLeft: 0,
        marginRight: 12,
    },
    lockedIcon: {
        backgroundColor: 'transparent',
    },
});

export default styles;
